import React from "react";
import moment from "moment";
import { DATE_TIME_FORMAT } from "../../../../Utils/Constants";

const AuditTrailTab = ({ auditTrailData }) => (
  <div className="vr-inner">
    <div className="vrt-content">
      {auditTrailData && auditTrailData.length > 0 ? (
        <div className="row">
          {auditTrailData.map((item, idx) => {
            const dateTime = moment.utc(item.action_datetime).local().format(DATE_TIME_FORMAT);
            const relativeTime = moment.utc(item.action_datetime).local().fromNow();
            const performedBy = `${item.full_name} (${item.company_name})`;
            const action = item.action_details;

            return (
              <div className="col-md-12" key={idx}>
                <div className="modal-graybox note-box audit-box atrail-box">
                  <div className="atrail-time">
                    <div className="graybox-split">
                      <p className="contact-text">{dateTime}</p>
                    </div>
                  </div>
                  <p className="atrail-right-text">{relativeTime}</p>
                  <p className="atrail-des">{action}</p>
                  <p className="atrail-name">By {performedBy}</p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-muted text-center py-5">📜 No audit trail available</p>
      )}
    </div>
  </div>
);

export default AuditTrailTab;